<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="dropzoneOptions"
      @vdropzone-removed-file="removeThisFile"
      @vdropzone-file-added="addedFile"
    ></vue-dropzone>
  </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import axios from 'axios'
  import {config} from '../shared/app.config'


  export default {
    name: 'ImageDropzone',
    components: {
      vueDropzone: vue2Dropzone
    },
    props: {
        files: {
            type: Array
        }
    },
    data () {
      return {
        deleteFileUrl: '',
        file: '',
        template: `
            <div class="dz-preview dz-file-preview">
              <div class="dz-details">
                <div class="dz-filename"><span data-dz-name></span></div>
                <div class="dz-size" data-dz-size></div>
                <img data-dz-thumbnail />
              </div>
              <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
              <div class="dz-success-mark"><span>✔</span></div>
              <div class="dz-error-mark"><span>✘</span></div>
              <div class="dz-error-message"><span data-dz-errormessage></span></div>
            </div>
        `,
        // https://www.dropzonejs.com/#configuration-options
        dropzoneOptions: {
          url: 'https://httpbin.org/post',
          paramName: 'myFile',
          thumbnailWidth: 200,
          maxFilesize: 0.48,
          maxFiles: 1,
          acceptedFiles: 'image/jpeg,image/png,image/jpg',
          dictDefaultMessage: this.$t('ArrastraArchivos'),
          dictFileTooBig: this.$t('ArchivoGrande'),
          wasQueueAutoProcess: false,
          autoQueue: true,
          addRemoveLinks: true,
          dictRemoveFile: 'Eliminar',
          accept(file, done) {
            if (file.fullPath !== undefined && (file.fullPath.includes('/') || file.fullPath.includes('\\'))) {
                done('Por favor, no se puede subir una carpeta, solo los archivos que están dentro');
                return;
            }
            done();
        },
          //previewTemplate: this.template
        }
      }
    },
    mounted () {
        const elementVue = this.$refs.myVueDropzone;
        if (this.files) {
            this.files.forEach(function (element) {
                const file = {
                    name: element.name,
                    type: 'image/png',
                    dataURL: element.url,
                    urlDelete: element.urlDelete,
                    width: 150,
                    height: 150,
                };
                elementVue.manuallyAddFile(file, element.url);
                elementVue.dropzone.emit('thumbnail', file, file.dataURL)
                elementVue.dropzone.emit('complete', file)
            });
        }
    },
    methods: {
      addedFile(){
        const errorImage=document.getElementsByClassName('dz-error-message');
        errorImage.forEach(item=>{

          item.style.top="10px";
        })

      },
      hasFilesRejected () {
        return this.$refs.myVueDropzone.getRejectedFiles().length > 0;
      },
      emptyDropzone () {
        const elementVue = this.$refs.myVueDropzone;
        elementVue.removeAllFiles();
      },
      removeThisFile (file) {
        this.deleteFileUrl = this.deleteFileUrl ? this.deleteFileUrl : file.urlDelete;
      },
      submitFiles () {
        const rejectedFiles = this.$refs.myVueDropzone.getRejectedFiles();

        if (this.hasFilesRejected()) {
          console.log('FILES REJECT', rejectedFiles);
        }

        const formData = this.getFormData();
        //'https://httpbin.org/post'
        const thisVs = this.$vs;
        axios.post(`${config.webApiBase}/app/attachment`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function () {
            thisVs.notify({title:'Imagen subida',text:':)',color:'success',position:'top-right'})
        })
          .catch(function () {
              thisVs.notify({title:'No ha sido posible subir la imagen',text:'',color:'danger',position:'top-right'})
          });
      }
      ,
      getFormData () {
        const formData = new FormData();
        const files = this.$refs.myVueDropzone.getAcceptedFiles();

        for (let i = 0; i < files.length; i++) {
          const file = files[i];

          formData.append(`myFile[${  i  }]`, file);
        }

        if (this.deleteFileUrl) {
              const thisVs = this.$vs;
              if (this.$refs.myVueDropzone.dropzone.disabled !== true) {
                  axios.delete(`${config.webApiBase}${  this.deleteFileUrl }`)
                      .then(function () {
                          thisVs.notify({title:'Imagen borrada',text:'',color:'success',position:'top-right'})
                      })
                      .catch(function () {
                          thisVs.notify({title:'No ha sido posible eliminar la imagen',text:'Error',color:'danger',position:'top-right'})
                      });
              }
          }

        return formData;
      }
    }
  }

</script>

<style>
  .dropzone .dz-preview .dz-image {
    width: 200px!important;
    height: 200px!important;
  }
  .dropzone .dz-preview .dz-image img {
    max-width: 200px;
  }
  .dropzone .dz-preview .dz-details .dz-size{
    display: none!important;
  }


.error_top{
  top: 10px
}
</style>
